import { render, staticRenderFns } from "./FallbackStrokeIcon.vue?vue&type=template&id=6123d2f4&"
import script from "./FallbackStrokeIcon.vue?vue&type=script&lang=js&"
export * from "./FallbackStrokeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports